import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconEmail2Unread: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconEmail2Unread"><Path d="M11.25 19.25H5.75C4.09315 19.25 2.75 17.9069 2.75 16.25V7.75C2.75 6.09315 4.09314 4.75 5.75 4.75H19.2387C20.3495 4.75 21.2499 5.65046 21.2499 6.76124C21.2499 7.5208 20.822 8.21557 20.1437 8.55736L13.3498 11.9805C12.5007 12.4084 11.4991 12.4084 10.65 11.9805L3 8.12597" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Circle cx="19.5" cy="17.5" r="3.5" fill="currentColor"/></CentralIconBase>;
});

export default IconEmail2Unread;
